var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row justify-content-center\">\r\n  <div class=\"col-6\">\r\n    <div class=\"summary-table\"></div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});